var MomentEnum;
(function (MomentEnum) {
    // ======= Formats =======
    // ------- Timezones
    MomentEnum["GMT"] = "Z";
    MomentEnum["UNIX"] = "X";
    // ------- Time
    MomentEnum["shortHour"] = "h";
    MomentEnum["hour"] = "hh";
    MomentEnum["fullHour"] = "HH";
    MomentEnum["fullMinute"] = "mm";
    MomentEnum["ampm"] = "a";
    MomentEnum["timeFormat"] = "hh:mm";
    // ------- Week Day
    MomentEnum["dayOfWeek"] = "d";
    MomentEnum["shortWeekDayName"] = "ddd";
    MomentEnum["fullWeekDayName"] = "dddd";
    // ------- Month Day
    MomentEnum["dayOfMonth"] = "D";
    MomentEnum["fullDayOfMonth"] = "DD";
    // ------- Month
    MomentEnum["fullMonthNumber"] = "MM";
    MomentEnum["shortMonthName"] = "MMM";
    MomentEnum["monthName"] = "MMMM";
    // ------- Year
    MomentEnum["fullYear"] = "YYYY";
    // ------- Combinations
    MomentEnum["yearMonthDay"] = "YYYY-MM-DD";
    MomentEnum["dayDateTime"] = "dddd, MMMM D - h:mma";
    MomentEnum["shortMomentDate"] = "MMM YYYY";
    // ======= Add & Subtract Formats =======
    MomentEnum["months"] = "M";
    MomentEnum["days"] = "d";
    // ======= String Constants =======
    MomentEnum["dayString"] = "day";
    MomentEnum["daysString"] = "days";
    MomentEnum["week"] = "week";
    MomentEnum["monthString"] = "month";
    MomentEnum["yearString"] = "year";
    MomentEnum["isoWeek"] = "isoWeek";
    MomentEnum["en"] = "en";
})(MomentEnum || (MomentEnum = {}));
export default MomentEnum;
//# sourceMappingURL=MomentEnum.js.map